import React from 'react'
import Select from '@react/react-spectrum/Select'

import './Picker.scss'

const Picker = ({ value, options, disabled, onChange, ...otherProps }) => {
  // Make sure value is not an array. If so, take the first argument
  const _value = (Array.isArray(value) && value.length ? value[0] : value) || ''

  return (
    <Select
      {...otherProps}
      className='Picker'
      value={_value}
      options={options}
      onSelect={onChange}
      disabled={disabled}
    />
  )
}

export default Picker
